'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WeeklyTimeWindowsIterator = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MergingStatusIterator = require('./MergingStatusIterator');

var _Status = require('./Status');

var Status = _interopRequireWildcard(_Status);

var _WeeklyTimeWindow = require('./WeeklyTimeWindow');

var WeeklyTimeWindow = _interopRequireWildcard(_WeeklyTimeWindow);

var _advanceCalendar = require('../utils/advanceCalendar');

var _advanceCalendar2 = _interopRequireDefault(_advanceCalendar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WeeklyTimeWindowsIterator = exports.WeeklyTimeWindowsIterator = function () {
    /**
     * @param weekly   List<WeeklyTimeWindow>
     * @param cal      Moment with tz
     */
    function WeeklyTimeWindowsIterator(_ref) {
        var _ref$weekly = _ref.weekly,
            weekly = _ref$weekly === undefined ? [] : _ref$weekly,
            cal = _ref.cal;

        _classCallCheck(this, WeeklyTimeWindowsIterator);

        weekly = weekly || []; // null weekly is supported, equivalent to empty weekly

        this._it = new _MergingStatusIterator.MergingStatusIterator({
            it: new WeeklyTimeWindowsIteratorImpl({
                weekly: weekly,
                cal: cal
            })
        });
    }

    /** @return Boolean */


    _createClass(WeeklyTimeWindowsIterator, [{
        key: 'hasNext',
        value: function hasNext() {
            return this._it.hasNext();
        }

        /** @return Status */

    }, {
        key: 'next',
        value: function next() {
            return this._it.next();
        }
    }]);

    return WeeklyTimeWindowsIterator;
}();

/**
 * @param cal   Moment with tz
 * @return Integer
 */


var minutesFromStartOfWeek = function minutesFromStartOfWeek(cal) {
    return (cal.day() - WeeklyTimeWindow.SUNDAY) * WeeklyTimeWindow.DAY + cal.hour() * WeeklyTimeWindow.HOUR + cal.minute();
};

var normalize = function normalize(weekly) {
    var normalized = [];

    var lastTimeWindow = null;
    for (var i = 0; i < weekly.length; ++i) {
        var timeWindow = JSON.parse(JSON.stringify(weekly[i]));
        if (lastTimeWindow) {
            if (lastTimeWindow.minuteOfWeek + lastTimeWindow.durationMins === timeWindow.minuteOfWeek) {
                lastTimeWindow.durationMins += timeWindow.durationMins;
            } else {
                normalized.push(lastTimeWindow);
                lastTimeWindow = timeWindow;
            }
        } else {
            lastTimeWindow = timeWindow;
        }
    }
    if (lastTimeWindow) {
        normalized.push(lastTimeWindow);
    }

    return normalized;
};

var WeeklyTimeWindowsIteratorImpl = function () {
    /**
     * @param weekly   List<WeeklyTimeWindow>
     * @param cal      Moment with tz
     */
    function WeeklyTimeWindowsIteratorImpl(_ref2) {
        var _ref2$weekly = _ref2.weekly,
            weekly = _ref2$weekly === undefined ? [] : _ref2$weekly,
            cal = _ref2.cal;

        _classCallCheck(this, WeeklyTimeWindowsIteratorImpl);

        weekly = normalize(weekly || []); // null weekly is supported, equivalent to empty weekly

        this._cal = cal.clone(); // "cal" is modified later, this allows the caller to reuse his version of it

        this._hasNext = true;
        this._timeWindows = [];
        this._isFirstAndLastSame = null;

        if (weekly.length === 0) {
            this._timeWindows.push({
                minuteOfWeek: 0,
                durationMins: WeeklyTimeWindow.WEEK,
                status: Status.STATUS_AVAILABLE
            });
            this._isFirstAndLastSame = true;
        } else {
            var minuteOfWeek = 0;
            for (var i = 0, l = weekly.length; i < l; ++i) {
                var timeWindow = weekly[i];
                if (timeWindow.minuteOfWeek > minuteOfWeek) {
                    this._timeWindows.push({
                        minuteOfWeek: minuteOfWeek,
                        durationMins: timeWindow.minuteOfWeek - minuteOfWeek,
                        status: Status.STATUS_UNAVAILABLE
                    });
                }
                this._timeWindows.push({
                    minuteOfWeek: timeWindow.minuteOfWeek,
                    durationMins: timeWindow.durationMins,
                    status: Status.STATUS_AVAILABLE
                });
                minuteOfWeek = this._endMinuteOfWeek(timeWindow);
            }
            if (minuteOfWeek < WeeklyTimeWindow.WEEK) {
                this._timeWindows.push({
                    minuteOfWeek: minuteOfWeek,
                    durationMins: WeeklyTimeWindow.WEEK - minuteOfWeek,
                    status: Status.STATUS_UNAVAILABLE
                });
            }

            var firstWindow = this._timeWindows[0];
            var lastWindow = this._timeWindows[this._timeWindows.length - 1];
            this._isFirstAndLastSame = firstWindow.status === lastWindow.status;
        }

        this._isConstant = this._timeWindows.length === 1;
    }

    /**
     * @param timeWindow   WeeklyTimeWindow
     * @return Integer
     */


    _createClass(WeeklyTimeWindowsIteratorImpl, [{
        key: '_endMinuteOfWeek',
        value: function _endMinuteOfWeek(timeWindow) {
            return timeWindow.minuteOfWeek + timeWindow.durationMins;
        }

        /** @return Boolean */

    }, {
        key: 'hasNext',
        value: function hasNext() {
            return this._hasNext;
        }

        /** @return Status */

    }, {
        key: 'next',
        value: function next() {
            if (this._isConstant) {
                this._hasNext = false;
                return {
                    status: this._timeWindows[0].status,
                    until: null
                };
            }

            var minuteOfWeek = minutesFromStartOfWeek(this._cal);
            var currentWindow = this._timeWindows[this._find(minuteOfWeek)];
            var newMinuteOfWeek = this._endMinuteOfWeek(currentWindow);
            if (newMinuteOfWeek === WeeklyTimeWindow.WEEK) {
                newMinuteOfWeek = this._isFirstAndLastSame ? this._endMinuteOfWeek(this._timeWindows[0]) : 0;
            }

            (0, _advanceCalendar2.default)(this._cal, newMinuteOfWeek);
            return {
                status: currentWindow.status,
                until: this._cal.valueOf()
            };
        }

        /**
         * @param minuteOfWeek   Integer
         * @return Integer index in _timeWindows member
         */

    }, {
        key: '_find',
        value: function _find(minuteOfWeek) {
            // _timeWindows are assumed to be sorted, so we can use binary search
            var low = 0;
            var high = this._timeWindows.length;

            while (low < high) {
                var mid = low + high >>> 1;
                var midValue = this._endMinuteOfWeek(this._timeWindows[mid]);
                if (midValue <= minuteOfWeek) {
                    low = mid + 1;
                } else {
                    high = mid;
                }
            }

            return low;
        }
    }]);

    return WeeklyTimeWindowsIteratorImpl;
}();